import React from 'react';
import { Form, Input, Select } from 'antd';
import CountryCodeDropdown from './countrycodedropdown'; // Import your custom CountryCodeDropdown component

const { Option } = Select;

const CustomInput = ({
    label,
    name,
    rules,
    placeholder,
    prefix,
    type,
    options,
    multiple,
    onCountrySelect, // Add a prop for the onCountrySelect handler
    defaultNumberInputValue
}) => {
    return (
        <Form.Item
            label={label}
            name={name}
            rules={rules}
        >
            {type === 'select' ? (
                <Select mode={multiple ? 'multiple' : undefined} placeholder={placeholder} allowClear>
                    {options?.map(option => (
                        <Option key={option.value} value={option.value}>
                            {option.label}
                        </Option>
                    ))}
                </Select>
            ) : name === 'phone' ? (
                <CountryCodeDropdown onSelect={onCountrySelect} defaultValue={defaultNumberInputValue} />
            ) : (
                <Input placeholder={placeholder} prefix={prefix} className='p-2' type={type} />
            )}
        </Form.Item>
    );
};

export default CustomInput;
